"use client";

import React, { useState, useCallback } from 'react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { Settings } from 'lucide-react';
import { ApiStatusDialog } from './api-status-dialog';

export function FloatingApiStatusButton() {
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    // Use useCallback to ensure the function reference is stable
    const handleButtonClick = useCallback((e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDialogOpen(true);
    }, []);

    // Only disable in production environments that are NOT UAT
    const isProductionNonUat = process.env.NODE_ENV === 'production' &&
        !(process.env.NEXT_PUBLIC_API_BASE_PATH?.includes('uat') || 
          process.env.NEXT_PUBLIC_API_BASE_PATH?.includes('staging') ||
          (typeof window !== 'undefined' && (
            window.location.hostname.includes('uat') ||
            window.location.hostname.includes('staging')
          )));

    // Don't render the button in production non-UAT environments
    if (isProductionNonUat) {
        return null;
    }

    return (
        <>
            <div 
                onClick={handleButtonClick}
                className="fixed bottom-6 right-6 z-50 cursor-pointer"
                style={{ pointerEvents: 'auto' }}
                role="button"
                tabIndex={0}
                aria-label="API Status & Configuration"
            >
                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <Button
                                className="h-12 w-12 rounded-full shadow-lg hover:shadow-xl transition-all duration-200"
                                size="icon"
                            >
                                <Settings className="h-5 w-5" />
                            </Button>
                        </TooltipTrigger>
                        <TooltipContent side="left">
                            <p>API Status & Configuration</p>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>
            </div>

            <ApiStatusDialog 
                open={isDialogOpen} 
                onOpenChangeAction={setIsDialogOpen}
            />
        </>
    );
}
